<script lang="ts">
  import type { CompanyInterface } from '$types/interfaces';
  import Button from '$components/elements/Button.svelte';

  export let company: CompanyInterface;
</script>

<div class="company">
  <div class="company__image"><img src={company.icon} alt={company.name} /></div>
  <h3>{company.name}</h3>
  <p>{company.text}</p>
  <Button
    icon="arrow-right"
    iconColor="#fff"
    href={company.href}
    target={company.href.startsWith('/') ? undefined : '_blank'}
  >
    {company.buttonText}
  </Button>
</div>

<style lang="scss">
  .company {
    background-color: #fff;
    padding: 50px 45px;
    border-radius: 13px;
    display: flex;
    flex-direction: column;
    gap: 22px;
    border: 1.5px solid rgba($color-medium-gray, 0.8);
    &__image {
      width: 100px;
      height: 100px;
      display: grid;
      place-content: center;
      background-color: $color-light-gray;
      border-radius: 50%;
      margin-bottom: 30px;
      img {
        height: 64px;
      }
    }
    h3 {
      font-size: 28px;
      line-height: 32px;
    }
    p {
      font-size: 17px;
      line-height: 32px;
      margin-bottom: auto;
    }
  }
  @include mobile {
    .company {
      gap: 24px;
      &__image {
        margin-bottom: 0;
      }
      p {
        font-size: 16px;
        line-height: 160%;
      }
    }
  }
</style>
